import Hguide from "../guides/Heb_guide2.pdf";
import Hguide1 from "../guides/Heb_guide.pdf";
import Eguide from "../guides/Eng_guide.pdf";
import backround from "../assets/backround.svg"

export default function Guide() {
    /* const aStyle = {
        textDecoration: 'none',
        fontFamily: 'Assistant-Bold, Assistant',
        marginBottom: '15px',
        fontSize: '26px',
        borderRadius: '50px',
        border: '4.5px solid #355279',
        background: '#9de4c6',
        padding: '20px 30px',
        width: '13rem',
        textAlign: 'center',
        color: '#355279',
        fontWeight: '700',
        cursor: 'pointer'
    }

    const a2Style = {
        textDecoration: 'none',
        fontFamily: 'Assistant-Bold, Assistant',
        marginBottom: '15px',
        fontSize: '26px',
        borderRadius: '50px',
        border: '4.5px solid #355279',
        background: '#fbfde8ff',
        padding: '20px 30px',
        width: '13rem',
        textAlign: 'center',
        color: '#355279',
        fontWeight: '700',
        cursor: 'pointer'
    }         */
        

    const headline = {
        backgroundImage: `url(${backround})`,
        margin: '0px',
        height: '17rem',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        color: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '28px',
        fontWeight: '600',
        backgroundPositionY: 'bottom'
    }

    return <>
        <div style={headline}>
            <h1>המדריך לשימוש אופטימלי של הכלי עבור המיזם שלכם</h1>
        </div>
        <div style={{ fontFamily: "Assistant-Bold, Assistant", color: '#355279', fontSize: "26px", width: "60%", margin: "10px auto", display: "flex", justifyContent: "space-evenly" }}>
            <div style={{ width: "50%" }}>
                <p>לפנייך מדריך אשר נועד לסייע במילוי השאלון. המדריך כולל הסבר מפורט על הכלי ורקע מורחב על השאלות המרכיבות את השאלון. ניתן למלא את השאלון גם ללא המדריך, אך אנו ממליצים לעיין במדריך ולהעזר בו במהלך מילוי השאלון באתר.</p>
                <p>בנוסף, המדריך עשוי להיות שימושי למי שרוצים להכיר טוב יותר את הכלי, את תהליך  העבודה ואת הרקע לשילוב בין השקעות אימפקט והתחדשות עירונית.</p>
                <p>הגרסה הראשונה של הכלי ראתה אור באפריל 2021, ועתה מוצגת הגרסה השניה. בגרסה 2.0 מוטמעים שינויים המבוססים על הניסיון הנצבר לאחר התנסות של גורמי מקצוע בכלי, ובהם חברות יזמיות, נציגי מחלקות הנדסה ואגפים אסטרסגיים בשלטון המקומי, שחקנים ממשלתיים ברשות הממשלתית להתחדשות עירונית ובמינהל התכנון וכן נציגי גופים מוסדיים וגופים העוסקים בהשקעות אימפקט וב – ESG. הגרסה המעודכנת של הכלי מתמקדת בפרויקטים שבהם מבוצעת הריסה ובניה בלבד (פינוי-בינוי ותמ"א 38/2), השאלות עודכנו בהתאם לשינויי רגולציה וכן נוסחים שנמצאו לא מפורטים או ברורים דיים עודכנו. </p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", marginTop: "26px"}}>
                <a href={Hguide} target="_blank" className="link-button-a" download>להורדת המדריך</a>
                <h4 style={{ textAlign: 'center' }}>גרסאות קודמות:</h4>
                <a href={Hguide1} target="_blank" className="link-button-b" download>המדריך גרסה 1.0</a>
                <a href={Eguide} target="_blank" className="link-button-b" download>EN Guide V 1.0</a>
            </div>
        </div>
    </>
}